import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Home as HomeIcon } from "lucide-react";
import { LOGO_URL, EA_BADGE_URL, COMPANY } from "@/lib/brand";
import GoogleReviewsBadge from "@/components/GoogleReviewsBadge";

export default function SiteFooter() {
  return (
    <footer id="contact" className="bg-white border-t border-slate-200" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 sm:px-10 py-14">
        <div className="grid gap-10 sm:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <img
                src={LOGO_URL}
                alt="Waites Clearances logo"
                className="h-14 w-14 rounded-2xl object-contain bg-white border border-slate-200"
              />
              <div>
                <p className="font-display font-extrabold text-slate-900 leading-tight">
                  Waites <span className="text-[#FF7F00]">Clearances</span>
                </p>
                <p className="text-xs text-slate-500">Family run in Peterborough</p>
              </div>
            </div>
            <p className="mt-5 text-sm text-slate-600 leading-relaxed max-w-xs">
              Fast, reliable and eco-friendly house clearances — treated with the same care as
              if it were our own home.
            </p>
            <div className="mt-5 flex items-start gap-3" data-testid="footer-ea-licence">
              <img
                src={EA_BADGE_URL}
                alt="Environment Agency Registered Waste Carrier"
                title="Environment Agency Registered Waste Carrier"
                className="h-10 w-auto object-contain shrink-0"
              />
              <p className="text-xs text-slate-500 leading-snug">
                Waste Carrier Licence No.
                <br />
                <span className="font-semibold text-slate-700">{COMPANY.wasteCarrierLicence}</span>
              </p>
            </div>
            <GoogleReviewsBadge variant="compact" className="mt-5" />
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#FF7F00]">
              Contact
            </p>
            <ul className="mt-4 space-y-3 text-sm text-slate-700" data-testid="footer-contact">
              <li className="font-display font-semibold text-slate-900">
                {COMPANY.tradingName}
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-[#FF7F00] mt-0.5 shrink-0" />
                <span>
                  {COMPANY.address.line1}
                  <br />
                  {COMPANY.address.line2}
                </span>
              </li>
              <li>
                <a
                  href={`tel:${COMPANY.phoneTel}`}
                  className="inline-flex items-center gap-2 text-slate-700 hover:text-[#FF7F00] font-medium"
                  data-testid="footer-phone"
                >
                  <Phone className="h-4 w-4 text-[#FF7F00]" /> {COMPANY.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="inline-flex items-center gap-2 text-slate-700 hover:text-[#FF7F00] font-medium break-all"
                  data-testid="footer-email"
                >
                  <Mail className="h-4 w-4 text-[#FF7F00] shrink-0" /> {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#FF7F00]">
              Quick links
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/services" className="text-slate-700 hover:text-[#FF7F00] font-medium">Services</Link></li>
              <li><Link to="/probate" className="text-slate-700 hover:text-[#FF7F00] font-medium">Probate clearances</Link></li>
              <li><Link to="/gallery" className="text-slate-700 hover:text-[#FF7F00] font-medium">Gallery</Link></li>
              <li><Link to="/areas" className="text-slate-700 hover:text-[#FF7F00] font-medium">Areas we cover</Link></li>
              <li><Link to="/reviews" className="text-slate-700 hover:text-[#FF7F00] font-medium">Reviews</Link></li>
              <li><Link to="/about" className="text-slate-700 hover:text-[#FF7F00] font-medium">About us</Link></li>
              <li><Link to="/contact" className="text-slate-700 hover:text-[#FF7F00] font-medium">Contact</Link></li>
              <li><Link to="/book" className="text-slate-700 hover:text-[#FF7F00] font-medium">Get a free quote</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-200 flex flex-wrap items-center justify-between gap-4 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} {COMPANY.tradingName}. All rights reserved.</p>
          <p className="inline-flex items-center gap-1.5">
            <HomeIcon className="h-3.5 w-3.5 text-[#FF7F00]" /> Peterborough &amp; nearby
          </p>
        </div>
      </div>
    </footer>
  );
}
